import React from "react";
import { Modal, Button } from "react-bootstrap";

const AdhocDetailModal = ({ show, onHide, adhoc }) => {
  if (!adhoc || !adhoc.id_adhocUser) return null;

  const user = adhoc.id_adhocUser;
  const client = adhoc.id_client;
  const vehicle = adhoc.id_vehicle;

  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "2-digit", day: "2-digit" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  const downloadImage = async (url, filename) => {
    const response = await fetch(url);
    const blob = await response.blob();
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Adhoc User Details</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          <strong>Name : </strong> {user.name}
        </p>
        <p>
          <strong>Phone Number : </strong> {user.phone_number}
        </p>
        <p>
          <strong>Client Name : </strong> {client?.name || "N/A"}
        </p>
        <p>
          <strong>Vehicle Number : </strong> {vehicle?.numberplate || "N/A"}
        </p>
        <p>
          <strong>Payment : </strong> {adhoc.payment || 0}
        </p>
        <p>
          <strong>Date : </strong>
          {formatDate(adhoc.date)}
        </p>
        <p>
          <strong>Created Date:</strong> {formatDate(user.createdAt)}
        </p>

        {/* Documents Section */}
        <div style={{ display: "flex", flexWrap: "wrap", gap: "20px" }}>
          {user?.aadharCard?.front?.url && (
            <div>
              <p>
                <strong>Aadhar Card Front Side : </strong>
              </p>
              <img
                src={user.aadharCard.front.url}
                alt="Aadhar Front"
                style={{ width: "100%" }}
              />

              <Button
                className="mt-2"
                variant="outline-primary"
                as="a"
                href={user.aadharCard.front.url}
                download="AadharCardFront.jpg"
                target="_blank"
                rel="noopener noreferrer"
              >
                Download
              </Button>
            </div>
          )}

          {user?.aadharCard?.back?.url && (
            <div>
              <p>
                <strong>Aadhar Card Back Side : </strong>
              </p>
              <img
                src={user.aadharCard.back.url}
                alt="Aadhar Back"
                style={{ width: "100%" }}
              />

              <Button
                className="mt-2"
                variant="outline-primary"
                as="a"
                href={user.aadharCard.back.url}
                download="AadharCard.jpg"
                target="_blank"
                rel="noopener noreferrer"
              >
                Download
              </Button>
            </div>
          )}
        </div>

        <br />

        {user?.dl?.url && (
          <div>
            <p>
              <strong>Driving License : </strong>
            </p>
            <img
              src={user.dl.url}
              alt="Driving License"
              style={{ width: "100%" }}
            />
            <Button
              className="mt-2"
              variant="outline-primary"
              as="a"
              href={user.dl.url}
              download="Driving_License.jpg"
              target="_blank"
              rel="noopener noreferrer"
            >
              Download
            </Button>
          </div>
        )}

        <br />

        {user?.photo?.url && (
          <div>
            <p>
              <strong>User Photo : </strong>
            </p>
            <img
              src={user.photo.url}
              alt="User Photo"
              style={{ width: "100%" }}
            />

            <Button
              className="mt-2"
              variant="outline-primary"
              as="a"
              href={user.photo.url}
              download="User_Photo.jpg"
              target="_blank"
              rel="noopener noreferrer"
            >
              Download
            </Button>
          </div>
        )}

        {user?.paymentQR?.url && (
          <div>
            <p>
              <strong>Payment QR : </strong>
            </p>
            <img
              src={user.paymentQR.url}
              alt="QR Code"
              style={{ width: "100%" }}
            />

            <Button
              className="mt-2"
              variant="outline-primary"
              as="a"
              href={user.paymentQR.url}
              download="QR_Code.jpg"
              target="_blank"
              rel="noopener noreferrer"
            >
              Download
            </Button>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AdhocDetailModal;
